import { Pipe, PipeTransform } from '@angular/core';
import { asYouType } from 'libphonenumber-js';

@Pipe({
    name: 'contactViewPipe',

})
export class contactViewPipe implements PipeTransform {
    transform(number: any, code: any) {
        // for US and Canada
        if (number && (number.indexOf('+') === -1 || number.indexOf('+1') !== -1)) {
            number = number.replace('+1', '');

            let cleaned = ('' + number.replace(/\D/g, '')).slice(0, 10);
            let formattedVal = cleaned;

            const zip = cleaned.substring(0, 3);
            const middle = cleaned.substring(3, 6);
            const last = cleaned.substring(6, 10);

            if (cleaned.length > 6) {
                formattedVal = `${zip}-${middle}-${last}`;
            } else if(cleaned.length > 3) {
                formattedVal = `${zip}-${middle}`;
            } else if(cleaned.length > 0) {
                formattedVal = `${zip}`;
            }

            return formattedVal;
            // return new asYouType('US').input(number);
        }
        return new asYouType().input(number);
    }
}